// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2MKXp","emails":"CreateEditClinics_emails__1JLV0","emailTagLabel":"CreateEditClinics_emailTagLabel__39d5W"};